import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBAnimation, MDBCard, MDBCardBody } from "mdbreact";

import TableLoading from "../../../../../components/tableLoading";
import Header from "./header";
import Body from "./body";
import Footer from "./footer";
import Modal from "./modal";
import { BROWSE as BROWSE_CLINICS } from "../../../../../services/redux/slices/diagnostics/clinic/clinicInfo";
import {
  BROWSE as BROWSE_INVENTORY,
  buildInventoryCacheKey,
  SetInventoryCacheKey,
} from "../../../../../services/redux/slices/diagnostics/clinic/clinicInventory";
import { BROWSE as BROWSE_MENUS } from "../../../../../services/redux/slices/diagnostics/clinic/clinicMenus";
import { getMenuPhysicians, getPhysicianRecordId } from "../menus/utils";
import { getBranchId, getClinicIds } from "./utils";

export default function ClinicSupplies() {
  const dispatch = useDispatch();
  const { token, activePlatform, auth } = useSelector(({ auth }) => auth);
  const { collections: clinics = [] } = useSelector(
    ({ clinicInfo }) => clinicInfo,
  );
  const { isLoading } = useSelector(({ clinicInventory }) => clinicInventory);

  const branchId = getBranchId(activePlatform);

  const clinicIds = React.useMemo(
    () =>
      getClinicIds({
        activePlatform,
        clinics,
        authId: auth?._id,
      }),
    [activePlatform, clinics, auth?._id],
  );

  const inventoryCacheKey = React.useMemo(
    () => buildInventoryCacheKey(clinicIds),
    [clinicIds],
  );
  const physicianIds = React.useMemo(
    () =>
      getMenuPhysicians({
        activePlatform,
        clinics,
        authId: auth?._id,
      })
        .map(getPhysicianRecordId)
        .filter(Boolean),
    [activePlatform, clinics, auth?._id],
  );

  React.useEffect(() => {
    dispatch(SetInventoryCacheKey(inventoryCacheKey));
  }, [dispatch, inventoryCacheKey]);

  React.useEffect(() => {
    if (!token || !branchId) return;

    dispatch(
      BROWSE_CLINICS({
        token,
        params: { branchId },
      }),
    );
  }, [dispatch, token, branchId]);

  React.useEffect(() => {
    if (!token || !clinicIds.length) return;

    dispatch(
      BROWSE_INVENTORY({
        token,
        key: { clinicIds: clinicIds.join(",") },
      }),
    );
  }, [dispatch, token, clinicIds]);

  React.useEffect(() => {
    if (!token || !physicianIds.length) return;

    dispatch(
      BROWSE_MENUS({
        token,
        key: { physicianId: physicianIds },
      }),
    );
  }, [dispatch, token, physicianIds]);

  return (
    <>
      <MDBAnimation type="bounceInDown">
        <MDBCard narrow className="pb-3" style={{ minHeight: "600px" }}>
          <Header />
          <MDBCardBody>{isLoading ? <TableLoading /> : <Body />}</MDBCardBody>
          <Footer />
        </MDBCard>
      </MDBAnimation>
      <Modal />
    </>
  );
}
